import { useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth } from '../authNew/authSlice';

// Guards authenticated routes by redirecting unauthenticated visitors to the login page.
export function AuthGuard() {
  const auth = useSelector(selectAuth);
  const navigate = useNavigate();
  const location = useLocation();

  // Redirects to login whenever the user is not authenticated.
  useEffect(() => {
    if (!auth.isLogged) {
      navigate('/login', { replace: true, state: { from: location.pathname } });
    }
  }, [auth.isLogged, navigate, location.pathname]);

  if (!auth.isLogged) {
    return null;
  }

  return <Outlet />;
}
